import { useQuery } from "@tanstack/react-query";

import { axios } from "@/admin/libs/axios";

export interface AdminDashboardEmbed {
  uid: string;
  title: string;
  url: string;
  // Seconds until the short-lived embed token expires. Clients are expected
  // to refetch before this window closes.
  expiresInSeconds: number;
}

export interface AdminAnalyticsIndex {
  dashboards: AdminDashboardEmbed[];
  // Signals whether Grafana is reachable at all. When false the UI shows a
  // setup-required empty state instead of an iframe that would 500.
  configured: boolean;
}

export const fetchAdminAnalytics = async (): Promise<AdminAnalyticsIndex> => {
  const { data } = await axios.get<AdminAnalyticsIndex>("/admin/analytics");
  return data;
};

export const useAdminAnalytics = () =>
  useQuery({
    queryKey: ["admin", "analytics"],
    queryFn: fetchAdminAnalytics,
    // Embed tokens are short-lived but Grafana config rarely changes; 2 min
    // is a sane middle ground that doesn't stampede the server.
    staleTime: 120_000,
  });
